































import { Component, Prop } from 'vue-property-decorator'
import Posts from '~components/content/Posts.vue'
import SearchPagination from '~components/content/widgets/pagination/SearchPagination.vue'
import RessortTitle from '~components/content/widgets/listings/RessortTitle.vue'

import { ListingPage, ListingPageVariables } from '~base/mixins/listings'
import {
  TermList,
  VueMetaProperty,
  VueMetaInfo,
  ApolloOperationVariables,
  ListingPageType,
} from '~base/common/types'

@Component<ListingPage & RessortPage>({
  components: {
    Posts,
    SearchPagination,
    RessortTitle,
  },

  head(): VueMetaInfo {
    return {
      title: this.title,
      meta: this.meta,
      link: this.link,
    }
  },

  apollo: {
    search: {
      query: require('~base/graphql/queries/FetchPostsForCategory.gql'),
      variables(): ListingPageVariables {
        return this.variables
      },
      prefetch({ route }: any): ListingPageVariables {
        return {
          first: this.perPage,
          page: parseInt(route.params.page || '0'),
          categories: [this.usedCategorySlug],
        }
      },
      result({ data }) {
        this.gotResult(data)
      },
    },
    categories: {
      query: require('~base/graphql/queries/FetchCategory.gql'),
      prefetch(): ApolloOperationVariables {
        return {
          slug: [this.usedCategorySlug],
        }
      },
      variables(): ApolloOperationVariables {
        return {
          slug: [this.usedCategorySlug],
        }
      },
    },
  },
})
export default class RessortPage extends ListingPage {
  @Prop({ type: String, default: undefined }) readonly category:
    | string
    | undefined

  private categories: TermList = { nodes: [] }
  protected type: ListingPageType = 'category'
  protected settingsKey = this.$route.params.category

  created() {
    this.settingsKey = this.category || this.settingsKey
    super.created()
  }

  get usedCategorySlug() {
    return this.category || this.$route.params.category
  }

  get sidebar() {
    return this.pageSettings.sidebar || 'ressort'
  }

  get title(): string {
    const prop = `seo.title.category.${this.usedCategorySlug}`
    let title = this.$root.$t(prop).toString()
    if (prop === title) {
      title = `${this.categoryName} - ${this.$root.$t(
        'seo.title.category.default'
      )}`
    }

    return title
  }

  get meta(): VueMetaProperty[] {
    const prop = `seo.description.category.${this.usedCategorySlug}`
    // related to vue-i18n issue #184 https://github.com/kazupon/vue-i18n/issues/184
    let description = this.$root.$t(prop).toString()
    if (prop === description) {
      description = this.$root
        .$t('seo.description.category.default', [this.categoryName])
        .toString()
    }
    return [
      ...super.meta,
      { hid: 'description', name: 'description', content: description },
      { hid: 'og:title', name: 'og:title', content: this.title },
      { hid: 'og:description', name: 'og:description', content: description },
    ]
  }

  get layouts() {
    return this.pageSettings.layouts || undefined
  }

  get categoryName() {
    const [cat] = this.categories ? this.categories.nodes : []
    return cat ? cat.name : this.usedCategorySlug
  }

  get linkPrefix(): string {
    return `/ressort/${this.usedCategorySlug}`
  }

  get variables(): ListingPageVariables {
    return {
      ...super.variables,
      categories: [this.usedCategorySlug],
    }
  }

  get titleComponent(): object | undefined {
    return super.titleComponent
  }

  mounted() {
    this.$store.dispatch('ads/pageChanged', {
      pageType: 'index',
      category: this.usedCategorySlug,
    })
    this.$store.dispatch('tracking/trackRessortPage', {
      category: this.$route.params.category,
      title: this.title,
    })
  }

  onTitleAction(_e: { [Identifier: string]: string }) {
    // do nothing for now
  }

  loadMoreData() {
    const { endCursor } = this.search.pageInfo
    if (endCursor) {
      this.after = endCursor
      this.nextPage()
    }
  }
}
